import { upgradeToPremium } from "../../../app/api/upgradeToPremium";
import { BaseAction } from "../../../core/actions/BaseAction";
import { IUpgradeExchangeToPremium } from "../../../Orchestrator/Types/Index";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IUpgradePremiumActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/UpgradePremiumAction";

class GetUpgradePremiumOfferAction extends BaseAction<IDefaultActionResult, IUpgradePremiumActionParams> {
    protected override deduplicate = true;
    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: [],
            message: "",
            status: "fail"
        }
        try {
            const { fulfillmentIds, passengers, bookingId, showLoader } = this.params!;            
            if (fulfillmentIds && passengers) {
                const payload: IUpgradeExchangeToPremium = {
                    fulfillmentIds: fulfillmentIds || [],
                    passengerRefs: passengers || [],
                    currency: "AED",
                    corporateCodes: null,
                    promotionCodes: null
                }
                const response: any = await upgradeToPremium(payload, bookingId, showLoader);
                if (response.status === 'ok' && response.answer) {
                    
                    // updateRecoilState("", )
                    actionResult.status = "success"
                    actionResult.data = response.answer
                }
            }
        } catch (error) {
            console.error("Error in GetUpgradePremiumOfferAction:", error);
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const getUpgradePremiumOfferAction = new GetUpgradePremiumOfferAction()


